import React from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";

import { EmptyContent } from "@ui/EmptyContent";
import { WaIcon } from "@ui/WaIcon";
import { Album as AlbumEl } from "../Album";
import { Album } from "../../models";
import { FormattedMessage } from "react-intl";
import { messages } from "../../messages";

interface Props {
    albums: Album[];
}

export const AlbumsPackList = ({ albums }: Props) => (
    <div className="albums-pack-list">
        {(albums == null || albums.length === 0) && (
            <EmptyContent>
                <h4 className="display-4">
                    <FormattedMessage {...messages.noAlbumsTitle} />
                </h4>
                <p><FormattedMessage {...messages.noAlbums} /></p>
                <Button tag={Link} color="primary" to="/albums/create">
                    <WaIcon name="add-outline" />{" "}
                    <FormattedMessage {...messages.addAProduct} />
                </Button>
            </EmptyContent>
        )}
        {albums && albums.length > 0 && (
            <ol>
                {albums.map((album, i) => <li key={i}><AlbumEl album={album} /></li>)}
            </ol>
        )}
    </div>
);
